import React from 'react';
import { motion } from 'framer-motion';
import CTAPair from '@/components/site/CTAPair';
import WhoWeWorkWith from '@/components/sections/WhoWeWorkWith';
import HowItWorks from '@/components/sections/HowItWorks';
import WhatWeOptimize from '@/components/sections/WhatWeOptimize';
import WhySellrly from '@/components/sections/WhySellrly';

export default function Services() {
  return (
    <div data-testid="page-services">
      <section className="relative overflow-hidden bg-[#000919] text-white">
        <div
          className="pointer-events-none absolute inset-0 opacity-55"
          style={{
            background:
              'radial-gradient(900px 500px at 85% 15%, rgba(138,1,230,0.18), transparent 60%), radial-gradient(700px 400px at 10% 95%, rgba(255,80,129,0.12), transparent 60%)',
          }}
        />
        <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-24 pb-20 md:pt-32 md:pb-28">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7">
              <motion.p
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-[-0.02em] text-[#FF5081]"
              >
                Services
              </motion.p>
              <motion.h1
                initial={{ opacity: 0, y: 14 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.05 }}
                className="mt-6 font-display text-[40px] sm:text-5xl lg:text-[56px] xl:text-[60px] font-semibold tracking-[-0.025em] leading-[1.02] capitalize"
              >
                We Run Media For Businesses That Need Buyers And Audiences — Not Just Impressions.
              </motion.h1>
              <motion.p
                initial={{ opacity: 0, y: 14 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.1 }}
                className="mt-7 max-w-2xl text-base lg:text-lg text-white/65 leading-relaxed"
              >
                If your growth depends on reaching the right people efficiently, building revenue and a sustainable
                business — Sellrly is built for you.
              </motion.p>
              <div className="mt-10">
                <CTAPair testIdSuffix="services-hero" secondaryTarget="#how-it-works" />
              </div>
            </div>

            <motion.div
              initial={{ opacity: 0, scale: 0.97 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="lg:col-span-5 relative"
            >
              <div className="relative aspect-square max-w-[520px] ml-auto">
                <div
                  className="absolute inset-0 -m-8 rounded-full opacity-60"
                  style={{
                    background: 'radial-gradient(circle at 50% 50%, rgba(255,80,129,0.18), transparent 65%)',
                  }}
                />
                <img
                  src="/brand/sellrly-services-header.svg"
                  alt="Sellrly services"
                  className="relative w-full h-full object-contain drop-shadow-[0_25px_80px_rgba(138,1,230,0.35)]"
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <WhoWeWorkWith titleCase />
      <HowItWorks titleCase />
      <WhatWeOptimize titleCase />
      <WhySellrly titleCase />
    </div>
  );
}
